<div class="max-w-content m-auto mt-10">
  <h1 class="text-red-600 text-3xl mb-11 mt-20 font-normal">Sales Sidekick is unavailable</h1>
  <p class="font-medium mb-6">For now, you’ll need to look up the info you need a different way. Apologies for the inconvenience!</p>
  <p class="font-medium mb-6">Look for an email coming soon with details on Sales Sidekick's availability.</p>
  <footer class="absolute bottom-0">
    <p>NFW-11765AO</p>
  </footer>
</div>
